module.exports = __webpack_public_path__ + "img/022.b3f7de9c.png";